<template>
  <OptionsMenuModal modal-id="map-options-dialog" :title="$t('map_options_dialog.options')" :has-pro="items.pro.length > 0">
    <OptionsMenuRow
      v-for="item in items.standard"
      :key="item.event"
      :icon="item.icon"
      :label="$t(item.labelKey)"
      @select="emitAndClose(item.event)"
    />
    <template #pro>
      <OptionsMenuRow
        v-for="item in items.pro"
        :key="item.event"
        :icon="item.icon"
        :label="$t(item.labelKey)"
        pro
        @select="emitAndClose(item.event)"
      />
    </template>
  </OptionsMenuModal>
</template>

<script setup>
import { computed } from 'vue'
import { Modal } from 'bootstrap'
import OptionsMenuModal from '../components/options_menu/OptionsMenuModal.vue'
import OptionsMenuRow from '../components/options_menu/OptionsMenuRow.vue'
import { mapOptionsItems } from './mapOptionsItems'

// Define props to control which options are visible
const props = defineProps({
  showEditDetails: {
    type: Boolean,
    default: false
  },
  editHike: {
    type: Boolean,
    default: true
  },
  showCreate: {
    type: Boolean,
    default: true
  },
  showWaypoints: {
    type: Boolean,
    default: true
  },
  showGoTo: {
    type: Boolean,
    default: true
  },
  showFlyover: {
    type: Boolean,
    default: false
  },
  showMeasurement: {
    type: Boolean,
    default: true
  },
  showPrint: {
    type: Boolean,
    default: true
  },
  showReportIssue: {
    type: Boolean,
    default: false
  },
  // Off by default: only pages that mount #download_modal / #embed-builder-app can open them.
  showDownload: {
    type: Boolean,
    default: false
  },
  showEmbed: {
    type: Boolean,
    default: false
  }
})

const items = computed(() => mapOptionsItems(props))

const emit = defineEmits(['edit-details','edit','create','reverse','waypoints','goto','flyover','measurement','print','report-issue','download','embed'])

function emitAndClose(evt){
  const el = document.getElementById('map-options-dialog');
  if (el) Modal.getOrCreateInstance(el).hide();
  emit(evt)
}

function open(){
  const el = document.getElementById('map-options-dialog');
  if (el) Modal.getOrCreateInstance(el).show();
}
defineExpose({ open })
</script>
